<template>
  <div>
    <el-dialog
      :visible.sync="noprocesado"
      width="360px"
      :top="'3vh'"
      :center="true"
      custom-class="modal-inner"
      :lock-scroll="true"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
      :destroy-on-close="false"
    >
      <div class="modalNoretira">
      <h3>Error al procesar reclamo</h3>
     <p>
    No pudimos procesar el reclamo, por favor intente nuevamente.
     </p>
 <el-button type="danger" size="default" @click="cancelar">Aceptar</el-button>
 
     </div>
    </el-dialog>
  </div>
</template>

<script>
import { EventBus } from "@/event-bus";
export default {
  data() {
    return {
      noprocesado: false,
    
    };
  },
  created() {
    EventBus.$on("verNoprocesado", (d) => {
       this.$store.commit('closeLoading', true)
       if(!d) this.noprocesado = true;
    
    });
 
   },

  methods: {
    
    cancelar()
    {
      
      this.noprocesado = false
    }
  },
};
</script>


<style lang="scss" scoped>
.modalNoretira h3{
  margin: 0;
}
</style>